import React from "react";

export const TaskCenterTableSkeleton: React.FC = () => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="h-12 border-b border-solid border-neutral-border bg-default-background">
            <th className="w-20 md:w-10 px-2 md:px-4 py-1 text-left">
            </th>
            <th className="w-24 md:w-28 px-2 md:px-4 py-1 text-left">
              <span className="text-body font-body text-subtext-color">Status</span>
            </th>
            <th className="w-40 md:w-60 px-2 md:px-4 py-1 text-left">
              <span className="text-body font-body text-subtext-color">Employee</span>
            </th>
            <th className="w-24 md:w-32 px-2 md:px-4 py-1 text-left">
              <span className="text-body font-body text-subtext-color">Tenure</span>
            </th>
            <th className="w-28 md:w-36 px-2 md:px-4 py-1 text-left">
              <span className="text-body font-body text-subtext-color">Escalation Reason</span>
            </th>
            <th className="w-24 md:w-28 px-2 md:px-4 py-1 text-left">
              <span className="text-body font-body text-subtext-color">Assignee</span>
            </th>
            <th className="w-24 md:w-32 px-2 md:px-4 py-1 text-left">
              <span className="text-body font-body text-subtext-color">Escalation Time</span>
            </th>
            <th className="w-16 px-2 md:px-4 py-1 text-left">
              <span className="text-body font-body text-subtext-color">Action</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 5 }).map((_, index) => (
            <tr key={index} className="border-b border-solid border-neutral-border bg-default-background">
              <td className="px-2 md:px-4 py-2">
                <div className="flex w-14 flex-none flex-col items-center gap-1">
                  <div className="h-4 w-4 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-3 w-12 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </td>
              <td className="px-2 md:px-4 py-2">
                <div className="h-6 w-20 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="px-2 md:px-4 py-2">
                <div className="flex flex-col items-start justify-center gap-1">
                  <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-3 w-32 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </td>
              <td className="px-2 md:px-4 py-2">
                <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="px-2 md:px-4 py-2">
                <div className="h-6 w-24 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="px-2 md:px-4 py-2">
                <div className="flex items-center gap-1">
                  <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-4 w-4 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </td>
              <td className="px-2 md:px-4 py-2">
                <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="px-2 md:px-4 py-2">
                <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}; 